export default [
  {
    action: "manage",
    resource: "administration",
    icon: "GridIcon",
    title: "Inici",
    route: "foravila-home",
  },
  {
    action: "manage",
    resource: "all",
    icon: "PieChartIcon",
    title: "Estadístiques",
    route: "foravila-stats",
  }
];
